function getLocation(setLocation) {
  let options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumWait: 10000, // max wait time for desired accuracy
    maximumAge: 0, // disable cache
    desiredAccuracy: 30, // meters
    fallbackToIP: true, // fallback to IP if Geolocation fails or rejected
  };
  const success = (pos) => {
    let crd = pos.coords;
    console.log("Your current position is:");
    console.log(`Latitude : ${crd.latitude}`);
    console.log(`Longitude: ${crd.longitude}`);
    console.log(`More or less ${crd.accuracy} meters.`);
    setLocation(crd);
  };
  const error = (err) => {
    console.log(`ERROR(${err.code}): ${err.message}`);
    fetch("https://get.geojs.io/v1/ip/geo.json")
      .then((r) => r.json())
      .then((res) => {
        console.log("ip location", res);
        setLocation(res);
      });
  };
  if (navigator && navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(success, error, options);
  } else {
    error({ code: 0, message: "sem api geolocation" });
  }
}

export default getLocation;
